/* ---------------------------------------------------------------------------
   MEL'S FLOWERS NZ — make the size selection feel instant.

   Measured before this existed, on one size change:
       0-44ms    main thread blocked by the theme's own click handling
       66ms      tile highlight, picker and recipe panel update
       658ms     PRICE finally updates
       ~2.3s     long tasks from third-party scripts keep the page janky

   The price was the slow part, and it is the number the shopper is watching.
   Nothing needed to be fetched for it: every tier's price is already known at
   render time, so it is written onto the label as data-mel-price and painted
   synchronously on change. The theme's own slower update still runs afterwards
   and writes the same value, so this is a head start, not a replacement — if
   this script never ran the page would behave exactly as before.

   Two deliberate limits:

   * A variant on sale is NOT painted here. The sale markup has its own
     compare-at nodes and badge, and getting that half-right would flash a wrong
     price. Two of 533 active variants are on sale, so the rare case simply
     waits for the theme. Fail towards showing nothing rather than a wrong price.

   * Nothing here touches the theme's own handlers, its fetches, or the variant
     state. It only writes text the theme is about to write anyway.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  var SETTLE_MS = 150;

  function labelFor(input) {
    if (!input.id) return input.closest ? input.closest('label') : null;
    var esc = window.CSS && CSS.escape ? CSS.escape(input.id) : input.id;
    return document.querySelector('label[for="' + esc + '"]') || (input.closest ? input.closest('label') : null);
  }

  /* Only the regular-price node, and only when the theme is not showing the
     sale layout. Anything unexpected means leaving the DOM alone. */
  function paintPrice(label) {
    if (!label) return false;
    var price = label.getAttribute('data-mel-price');
    if (!price) return false;
    if (label.getAttribute('data-mel-onsale') === '1') return false;

    var box = document.querySelector('.price__box_wrapper');
    if (!box) return false;
    var priceEl = box.querySelector('.price__regular .price-item--regular');
    if (!priceEl) return false;
    if (box.querySelector('.price--on-sale')) return false;

    if (priceEl.textContent.trim() !== price) priceEl.textContent = price;
    return true;
  }

  /* Coalescing. A shopper stepping Regular -> Deluxe -> Supersize fires three
     changes in well under a second. The price paint runs on every one of them
     because it is a single text write and must never lag behind the selection.
     Everything else waits until the clicking stops, so the settle work runs
     once instead of three times. */
  var settleTimer = null;
  var lastPainted = null;

  function settle() {
    settleTimer = null;
    // Re-assert against whatever the theme rendered in the meantime.
    var checked = document.querySelector('.mels-flo-tile-radio:checked, input[type="radio"]:checked');
    if (checked) paintPrice(labelFor(checked));
  }

  function onChange(e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var label = labelFor(t);
    if (!label || !label.classList.contains('variant-tile')) return;

    if (paintPrice(label)) lastPainted = label.getAttribute('data-mel-price');

    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, SETTLE_MS);
  }

  document.addEventListener('change', onChange, true);

  /* The theme re-renders the picker after a change, which replaces the labels.
     Re-painting once after that keeps the head start from being undone, without
     observing the whole document. */
  var infoRoot = document.querySelector('.product__info-container');
  if (infoRoot && window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending || settleTimer) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        var checked = document.querySelector('.mels-flo-tile-radio:checked');
        if (!checked) return;
        var label = labelFor(checked);
        if (label && label.getAttribute('data-mel-price') !== lastPainted) return;
        paintPrice(label);
      });
    }).observe(infoRoot, { childList: true, subtree: true });
  }
})();
